<template>
  <div class="layout-breadcrumb-container flex justify-content-between align-items-center shadow-1">
    <VBreadcrumb  :model="items" class="layout-breadcrumb pl-4 py-2"></VBreadcrumb>

    <div class="layout-breadcrumb-buttons flex align-items-center pr-3">

    </div>
  </div>
</template>

<script>
import {capitalize} from "vue";
import VBreadcrumb from "@/primevue/breadcrumb/Breadcrumb.vue";
export default {
  components:{VBreadcrumb},
  data() {
    return {
      items: []
    }
  },
  watch: {
    $route() {
      this.watchRouter();
    }
  },
  created() {
    this.watchRouter();
  },
  methods: {
    watchRouter() {
      if(this.$router.currentRoute.value.meta.breadcrumb) {
        this.items = [];
        const b = this.$router.currentRoute.value.meta.breadcrumb;
        for(let i = 0; i < b.length; i++) {
          const bc = this.$router.currentRoute.value.meta.breadcrumb[i];
          for(let pro in bc) {
            this.items.push({label: capitalize(this.$t(bc[pro]))});
          }
        }
      }
    }
  }
}
</script>

<style scoped>

</style>
